import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Tooltip, Input, Typography } from "antd";
import axios from "axios";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const LivestockDamageForm = props => {
  const [form] = Form.useForm();

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        numberOfDead: props.record.damage.numberOfDead,
        numberOfInjured: props.record.damage.numberOfInjured,
        numberOfMissing: props.record.damage.numberOfMissing,
        numberOfDiseased: props.record.damage.numberOfDiseased,
        diseaseDescription: props.record.damage.diseaseDescription
      });
    }
  }, [props.record.damage, form]);

  const onValuesChange = (changedValues) => {
    form.validateFields(Object.keys(changedValues));
  };

  const onFieldsChange = (changedFields, allFields) => {
    const fieldsError = form.getFieldsError();
    var valid = fieldsError.every(field => !field.errors || field.errors.length === 0);
    
    const values = form.getFieldsValue();
    const newDamage = { ...props.record };
    newDamage.damage.numberOfDead = elvis(values.numberOfDead);
    newDamage.damage.numberOfInjured = elvis(values.numberOfInjured);
    newDamage.damage.numberOfMissing = elvis(values.numberOfMissing);
    newDamage.damage.numberOfDiseased = elvis(values.numberOfDiseased);
    newDamage.damage.diseaseDescription = elvis(values.diseaseDescription);
    newDamage.valid = valid;
    props.parentCallback(newDamage);
  };

  return (
    <Form 
      {...formItemLayout} 
      className="details_form"
      form={form}
      onValuesChange={onValuesChange}
      onFieldsChange={onFieldsChange}
      name="livestockDamage"
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Livestock"
      />
      <Form.Item label="N. of dead" name="numberOfDead">
        <InputNumber />
      </Form.Item>
      <Form.Item label="N. of injured" name="numberOfInjured">
        <InputNumber />
      </Form.Item>
      <Form.Item label="N. of missing" name="numberOfMissing">
        <InputNumber />
      </Form.Item>
      <Form.Item label="N. of diseased" name="numberOfDiseased">
        <InputNumber />
      </Form.Item>
      <Form.Item label="Disease description" name="diseaseDescription">
        <Input />
      </Form.Item>
    </Form>
  );
};

export default LivestockDamageForm;